import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0003 16.0546C13.0061 16.234 12.9611 16.4113 12.8704 16.5662C12.7797 16.721 12.6469 16.847 12.4876 16.9295C12.3354 17.0001 12.1641 17.0183 12.0004 16.9813C11.8367 16.9442 11.69 16.854 11.583 16.7248L6.24283 10.662C6.086 10.4756 6 10.2398 6 9.99621C6 9.75261 6.086 9.51683 6.24283 9.33044L11.5812 3.27465C11.6881 3.14577 11.8346 3.05582 11.9979 3.0188C12.1611 2.98178 12.3321 2.99975 12.4841 3.06993C12.6434 3.15246 12.7762 3.27843 12.8669 3.43325C12.9576 3.58808 13.0026 3.76544 12.9968 3.9448L13.0003 16.0546Z",
		fill: "#0D2976"
	})
});
export default SvgCaretLeft;
